import { Checkbox } from "@mui/material";
import { pink } from "@mui/material/colors";
import React from "react";
import { Controller } from "react-hook-form";

const CheckTerms = ({ control }) => {
  return (
    <section className="my-8">
      <div className="flex">
        <Controller
          name="checkbox"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <Checkbox
              {...field}
            //   defaultChecked
              sx={{
                color: pink[300],
                marginTop: "-10px",
                "&.Mui-checked": {
                  color: pink[300],
                },
                "& .MuiSvgIcon-root": { fontSize: 28 },
              }}
            />
          )}
        />

        <p className="text-sm">
          by signing up, you agree to the{" "}
          <span className="text-red">terms of service and privacy policy</span>
        </p>
      </div>
    </section>
  );
};

export default CheckTerms;
